<template>
	<div>
		<Header></Header>
		<Nav></Nav>
		<div class="purch">
			<div class="purchase">
				<h3 class="pur-txt">采购审批权限设置</h3>
				<div class="cation">
					<div class="unwanted public" :class="{active:isActive== 3}" @click="unjudge(3)">无需审核
						<div class="triangle" :class="{playtriangle:isActive== 3}"></div>
					</div>
					<div class="commodity public" :class="{active:isActive== 1}" @click="unjudge(1)">指定商品分类审核
						<div class="triangle" :class="{playtriangle:isActive== 1}"></div>
					</div>
					<div class="commodity public" :class="{active:isActive== 4}" @click="unjudge(4)">指定商品审核
						<div class="triangle" :class="{playtriangle:isActive== 4}"></div>
					</div>
					<div class="money public" :class="{active:isActive== 2}" @click="unjudge(2)">根据订单金额审核
						<div class="triangle" :class="{playtriangle:isActive== 2}"></div>
					</div>
				</div>
				<div v-show="judge == 3" class="pub" @click="auditNull()">保存</div>
				<div v-show=" judge == 2" class="order">
					<p class="order-p">订单超过将审核：</p>
					<input class="mon" v-model="examine_price" placeholder="输入多少金额" />
					<div class="pub pub-mon" @click="auditAmount()">保存</div>
				</div>
				<div v-show="judge == 1" class="commodity-com">
					<div class="com-goods-ss">
						<p class="com-right-txt">添加商品类别：</p>
						<input class="com-right-txt-inp" v-model="class_txt" ref="class_txt"/>
						<div class="com-goods-zhao" @click="lookupClass">查找商品类别</div>
					</div>
					<div class="hide">
						<div class="hide-center">  <!--  -->
							<div class="hide-class" v-for="(item,index) in list" :class="{'active-class': class_id.indexOf(item.id)!=-1}" @click="showdifference(item,index)" >
								<div class="class-triangle" :class="{'classtriangle': class_id.indexOf(item.id)!=-1}"></div>
								<img :src="item.pic_url" />
								<p>{{item.name}}</p>
							</div>
						</div>
						<el-pagination class="ttshop-pages" @current-change="handleCurrentChangeClass" :current-page.sync="class_page" background
						 layout="prev, pager, next" @prev-click="class_perv" @next-click="class_next" :page-count="class_list_num"></el-pagination>
						<div class="pub pub-com-class" @click="auditGoods()">保存</div>
					</div>
				</div>
				<div v-show="judge == 4" class="commodity-goods">
					<div class="com-goods-ss">
						<p class="com-right-txt">添加商品：</p>
						<input class="com-right-txt-inp" v-model="goods_txt" ref="goods_txt"/>
						<div class="com-goods-zhao" @click="lookupGoods()">查找商品</div>
					</div>
					<ul class="com-right-ul">
						<li v-for="(item,index) in goods_list">
							<input type="checkbox" v-model="goods_id" :value="item.id" @click="goodsNews(item,index)"/>
							<img v-lazy="item.cover_pic" />
							<p>{{item.name}}</p>
						</li>
					</ul>
					<el-pagination class="ttshop-pages" @current-change="handleCurrentChangeGoods" :current-page.sync="goods_page" background
					 layout="prev, pager, next" @prev-click="goods_perv" @next-click="goods_next" :page-count="goods_list_num"></el-pagination>
					<div class="pub pub-com-goods" @click="auditGoods()">保存</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Nav from "@/components/purchase/nav/nav";
	import Footer from "@/components/purchase/footer/footer";
	import "./purchase.css"
	export default {
		components: {
			Header,
			Nav,
			Footer
		},
		data() {
			return {
				route_url: this.$store.state.route_url,
				judge: 1,
				isActive: 1,
				isClass: -1,
				list: [], //商品分类数据
				id: "", //分类id
				pu_id: "", //企业id
				name: "", //分类名称
				parend_id: "", //父级id
				goods_list: [], //商品列表
				examine_price: "", //审核金额
				class_id: [], //需要审核分类id
				goods_id: [], //需要审核商品的id
				class_page: 1,   //分类分页
				class_count: 24,  //分类分页单页请求条数
				class_list_num: 0,  //分类分页总页数
				goods_page: 1,   //商品分页
				goods_count: 6,  //商品分页单页请求条数
				goods_list_num: 0,  //商品分页总页数
				class_txt: '',   //分类关键字查找
				goods_txt: '',   //商品关键字查找
			};
		},
		created() {
			this.auditSetting();
			this.examineGoods();
			this.auditDetails();
			// this.examine_price = this.$store.state.examine_price;
			let that = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					// 审核分类查找
					if (that.$refs.class_txt.value) {
						that.auditSetting();
					}
					// 审核商品查找
					if (that.$refs.goods_txt.value) {
						that.examineGoods();
					}
				}
			};
		},
		mounted() {
			document.querySelector('body').setAttribute('style', 'background-color:#F2F2F2')
		},
		beforeDestroy() {
			document.querySelector('body').removeAttribute('style')
		},
		methods: {
			//分类输入关键字查找
			lookupClass(){
				this.auditSetting()
			},
			// 获取审核分类列表
			auditSetting() {
				this.$api.auditClassification({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					page: this.class_page,
					limit:this.class_count,
					keyword: this.class_txt,
				}).then((res) => {
					this.list = res.data.list;
					this.class_list_num = res.data.page_count;
				}).catch((err) => {
					// console.log(err);
				});
			},
			//商品输入关键字查找
			lookupGoods(){
				this.examineGoods()
			},
			//获取审核商品列表
			examineGoods() {
				this.$api.reviewGoods({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					page: this.goods_page,
					limit:this.goods_count,
					keyword:this.goods_txt,
				}).then((res) => {
					this.goods_list = res.data.list;
					this.goods_list_num = res.data.page_count;
				}).catch((err) => {
					// console.log(err);
				});
			},
			unjudge(i) {
				this.judge = i,
				this.isActive = i
			},
			// 数组去重
			// unique(arr) {
			// 	return Array.from(new Set(arr))
			// },
			//审核详情
			auditDetails(){
				this.$api.qycgAuditDetails({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					this.class_id = res.data.examine_cats;
					this.examine_price = res.data.examine_price;
					this.goods_id = res.data.examine_goods;
					// console.log(this.class_id);
					// console.log(this.goods_id);
					// console.log(this.examine_price);
				}).catch((err) => {
					// console.log(err);
				});
			},
			//商品分类需要审核列表
			showdifference(item,index) {
				let id = this.list[index].id;
				// console.log(id)
				let classId = this.class_id.indexOf(id);
				if (classId == "-1") {
					this.isClass = index;
					this.class_id.push(id);
				} else {
					this.isClass = -1;
					let index = this.class_id.indexOf(id)
					this.class_id.splice(index,1);
				}
				// console.log(this.class_id)
			},
			//商品需要审核列表
			goodsNews(item,index) {
				let id = this.goods_list[index].id + "";
				let goodsId = this.goods_id.indexOf(id)
				if (goodsId == -1) {
					this.goods_id.push(id);
				} else {
					let index = this.goods_id.indexOf(id)
					this.goods_id.splice(index,1);
				}
			},
			
			// 无需审核
			auditNull() {
				this.$api.auditSettings({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					examine_type: 0,
				}).then((res) => {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
				}).catch((err) => {
					// console.log(err);
				});
			},
			// 审核金额
			auditAmount() {
				let examine_price = this.examine_price;
				this.$api.auditSettings({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					examine_type: 2,
					examine_price: examine_price,
				}).then((res) => {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
				}).catch((err) => {
					// console.log(err);
				});
			},
			// 审核分类/商品
			auditGoods() {
				var goods_id = this.goods_id.toString();
				var class_id = this.class_id.toString();
				// console.log(class_id)
				// console.log(goods_id)
				// goods_id = goods_id.slice(0, class_id.length - 1);
				// class_id = class_id.slice(0, class_id.length - 1);
				this.$api.auditSettings({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					examine_type: 1,
					examine_goods: goods_id,
					examine_cats: class_id,
				}).then((res) => {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.examineGoods();
					this.auditSetting();
				}).catch((err) => {
					// console.log(err);
				});
			},
			// handleSizeChange(val) {
			//     console.log(`每页 ${val} 条`);
			// },
			// handleCurrentChange(val) {
			//     console.log(`当前页: ${val}`);
			// },
			// 分类输入分页
			handleCurrentChangeClass(e) {
				this.class_page = e;
				this.common.backTop();
				this.auditSetting();
			},
			//分类上一页
			class_perv() {
				this.class_page--;
				this.common.backTop();
				this.auditSetting();
			},
			// 分类下一页
			class_next() {
				this.class_page++;
				this.common.backTop();
				this.auditSetting();
			},
			
			// 商品输入分页
			handleCurrentChangeGoods(e) {
				this.goods_page = e;
				this.common.backTop();
				this.examineGoods();
			},
			//商品上一页
			goods_perv() {
				this.goods_page--;
				this.common.backTop();
				this.examineGoods();
			},
			// 商品下一页
			goods_next() {
				this.goods_page++;
				this.common.backTop();
				this.examineGoods();
			},

			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.purch {
		width: 100%;
		height: 100%;
		background: #F7F8FA;
		background-color: #F2F2F2;
		padding-top: 20px;

		.purchase {
			margin: 0 auto;
			padding-top: 32px;
			padding-bottom: 80px;
			width: 1080px;
			box-sizing: border-box;
			// width: 57%;
			// height: 100%;
			min-height: 409px;
			background: #FFFFFF;

			.pur-txt {
				width: 144px;
				height: 20px;
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 20px;
				margin-left: 32px;
			}

			.cation {
				display: flex;
				margin-top: 25px;
				margin-left: 32px;

				.public {
					cursor: pointer;
					padding: 0 12px;
					margin-right: 16px;
					height: 34px;
					line-height: 34px;
					text-align: center;
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					background: #FFFFFF;
					border-radius: 2px;
					border: 1px solid #EBEBEB;
					position: relative;
				}

				.triangle {
					position: absolute;
					bottom: -6px;
					right: -6px;
					width: 0px;
					height: 0px;
					content: " ";
					border-right: 6px solid transparent;
					border-top: 6px solid transparent;
					border-left: 6px solid transparent;
					border-bottom: 6px solid transparent;
					transform: rotate(135deg);
				}

				.playtriangle {
					border-bottom: 6px solid #FF0E25;
				}

				.active {
					border: 1px solid #FF0E25;
				}
			}

			// judge==3  无需审核显示
			.pub {
				width: 108px;
				height: 32px;
				margin-top: 30px;
				margin-left: 32px;
				cursor: pointer;
				background: #FF0E25;
				border-radius: 2px;
				font-size: 12px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #FFFFFF;
				text-align: center;
				line-height: 32px;
			}

			// judge==2  根据订单金额审核显示
			.order {
				.order-p {
					width: 112px;
					height: 20px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					margin-top: 40px;
					margin-left: 32px;
					color: #333333;
					line-height: 20px
				}

				.mon {
					width: 379px;
					height: 40px;
					margin-top: 12px;
					margin-left: 32px;
					background: #FFFFFF;
					border-radius: 2px;
					border: 1px solid #EBEBEB;
					text-indent: 5px;
				}

				.pub-mon {
					margin-top: 32px;
				}
			}

			// judge==1  制定商品或商品类型显示审核显示
			.commodity-com {
				width: 1080px;
				margin-top: 38px;
				margin-left: 32px;
				max-height: 600px;
				.com-goods-ss{
					margin-top: 15px;
					height: 32px;
					display: flex;
					line-height: 32px;
					margin-bottom: 32px;
					.com-right-txt{
						font-size: 14px;
						text-align: center;
						margin-right: 18px;
					}
					.com-right-txt-inp{
						width: 240px;
						height: 32px;
						border-radius: 4px 0px 0px 4px;
						border: 1px solid #CCCCCC;
						box-sizing: border-box;
						text-indent: 12px;
					}
					.com-goods-zhao{
						width: 124px;
						height: 32px;
						background: #FF0E25;
						border-radius: 0px 4px 4px 0px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 32px;
						text-align: center;
						cursor: pointer;
					}
				}
				.hide{
					.hide-center{
						width: 1012px;
						min-height: 367px;
						display: flex;
						 flex-wrap: wrap;/*换行*/
						.hide-class{
							box-sizing: border-box;
							cursor: pointer;
							width: 109px;
							height: 109px;
							border-radius: 4px;
							border: 1px solid #E6E6E6;
							margin-right: 20px;
							margin-bottom: 20px;
							position: relative;
							.class-triangle {
								position: absolute;
								bottom: -6px;
								right: -6px;
								width: 0px;
								height: 0px;
								content: " ";
								border-right: 6px solid transparent;
								border-top: 6px solid transparent;
								border-left: 6px solid transparent;
								border-bottom: 6px solid transparent;
								transform: rotate(135deg);
							}
							
							.classtriangle {
								border-bottom: 6px solid #FF0E25;
							}
							
							img{
								width: 56px;
								height: 56px;
								margin: 12px auto 8px;
							}
							p{
								text-align: center;
							}
						}
						.active-class {
							border: 1px solid #FF0E25;
						}
						.hide-class:nth-child(8n){
							margin-right: 0;
						}
					}
				}

					.pub-com-class {
						margin: 0 auto;
					}
			}

			// judge==4  制定商品审核显示
			.commodity-goods {
				
				width: 1080px;
				margin-top: 38px;
				margin-left: 32px;
				max-height: 600px;
				.com-goods-ss{
					margin-top: 15px;
					height: 32px;
					display: flex;
					line-height: 32px;
					margin-bottom: 32px;
					.com-right-txt{
						font-size: 14px;
						text-align: center;
						margin-right: 18px;
					}
					.com-right-txt-inp{
						width: 240px;
						height: 32px;
						border-radius: 4px 0px 0px 4px;
						border: 1px solid #CCCCCC;
						box-sizing: border-box;
						text-indent: 12px;
					}
					.com-goods-zhao{
						width: 124px;
						height: 32px;
						background: #FF0E25;
						border-radius: 0px 4px 4px 0px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 32px;
						text-align: center;
						cursor: pointer;
					}
				}
					.com-right-ul {
						width: 1048px;
						min-height: 367px;
						overflow: auto;

						li {
							display: flex;
							height: 57px;
							align-items: center;
							// justify-content: center;
							margin-bottom: 5px;

							input {
								margin-right: 12px;
							}

							img {
								width: 56px;
								height: 57px;
								// border: 1px dashed;
								margin-right: 12px;
							}

							p {
								width: 650px;
								font-size: 14px;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #333333;
								padding-right: 30px;
								padding: 0 5px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
							}
						}
					.pub-com-goods {
						margin-top: 30px;
						margin-left: 100px;
					}
				}
			}
		}
	}
</style>
